import { render, staticRenderFns } from "./TelegramChatIdentifyModal.vue?vue&type=template&id=7fab1430&lang=pug&"
import script from "./TelegramChatIdentifyModal.vue?vue&type=script&lang=js&"
export * from "./TelegramChatIdentifyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports